import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-create-account',
  templateUrl: './create-account.component.html',
  styleUrls: ['./create-account.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
/**
 * Create business representative account template
 */
export class CreateAccountComponent {}
